import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

type MobileVacationSummaryProps = {
  totalVacationCount: number
}

const MobileVacationSummary = ({ totalVacationCount }: MobileVacationSummaryProps) => {
  const { t } = useTranslation()

  return (
    <Box sx={{ marginTop: 2, textAlign: 'center' }}>
      <Typography variant="body1">
        {t('page.vacationView.sum')}: {totalVacationCount}{' '}
        <span style={{ color: '#999999' }}>{t('page.vacationView.days')}</span>
      </Typography>
    </Box>
  )
}

export default MobileVacationSummary
